angular.module('leanlaw')
//TODO
.filter('nonModalAlerts', function () {
  return function (alerts) {
    return alerts;
  };
}).filter('firstModalAlert', function () {
  return function (alerts) {
    return [];
  };
});